<template>
  <v-app>
    <v-main>
      <v-row>
        <developer-dashboard-card
          v-for="(card, i) in cards"
          :key="i"
          :title="card.title"
          :route="card.route"
        />
      </v-row>
    </v-main>
  </v-app>
</template>
<script>
import developerDashboardCard from './developerDashboardCard';

export default {
  components: {
    developerDashboardCard
  },

  data() {
    return {
      'cards': [
        {
          'title': 'Pages',
          'route': 'pages',
        },
        {
          'title': 'Submissions',
          'route': 'submissions',
        },
        {
          'title': 'Posts',
          'route': 'posts',
        },
        {
          'title': 'Users',
          'route': 'users',
        },
      ],
    }
  },
};
</script>
